// extracted by mini-css-extract-plugin
module.exports = {"button":"OutboundIntegrationTable_button__17VzE","asset-button":"OutboundIntegrationTable_asset-button__3XLzC"};